var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"asg-table-card"},[_c('div',{staticClass:"asg-table-card_header"},[_vm._t("header")],2),_c('div',{staticClass:"asg-table-card_content"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }